// Ordering for peer group lists, shared by the dashboard list
// (PeerGroupList.vue) and the bulk archive dialog (PeerGroupBatchDialog.vue),
// which both show PeerGroupSortControl.vue.

import { BasePeerGroup } from '@/models';
import { PeerGroupSort, PeerGroupSortField } from '@/preferences';
import * as Utils from '@/utils';

export const peerGroupComparator = ({
  field,
  descending
}: PeerGroupSort): ((a: BasePeerGroup, b: BasePeerGroup) => number) => {
  if (field === 'createdAt') {
    return (a, b) => Utils.sortByDate(a, b, pg => pg.createdAt, descending);
  }

  return (a, b) => Utils.sortNamed(a, b, descending);
};

/**
 * The sort after the viewer picks `field`.  Reselecting the active field flips
 * it; a new field starts at its own default, since names read best A-Z and
 * dates read best newest first.
 */
export const nextPeerGroupSort = (
  current: PeerGroupSort,
  field: PeerGroupSortField
): PeerGroupSort => ({
  field,
  descending:
    field === current.field ? !current.descending : field === 'createdAt'
});
